import script from "./ShipperAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipperAddress.vue?vue&type=script&setup=true&lang=js"

import "./ShipperAddress.vue?vue&type=style&index=0&id=32854cf4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32854cf4"]])

export default __exports__